import type { VoidFunctionComponent } from 'react';

import { ignoredAtFromProjects, ignoredKindsFromProjects } from '../../../../helpers/issuesV2';
import CustomRiskScoreBadge from '../../../generic/CustomRiskScoreBadge';
import VulnBadge from '../../../generic/VulnBadge';
import type { VulnIssue } from '../../../../../shared/issuesV2';

import BaseIssueItem from './BaseIssueItem';
import VulnerabilityIssueItemContent from './BaseIssueItem/VulnerabilityIssueItemContent';

type VulnerabilityIssueItemProps = {
  issue: VulnIssue;
};

/**
 * Represents a Vulnerability issue (which is a type of security issue).
 */
const VulnerabilityIssueItem: VoidFunctionComponent<VulnerabilityIssueItemProps> = ({ issue }) => {
  const { customRiskScore } = issue;

  return (
    <BaseIssueItem id={issue.id} issue={issue}>
      <VulnerabilityIssueItemContent
        issue={issue}
        locator={issue.source.id}
        title={issue.title}
        createdAt={issue.createdAt}
        ignoredAt={ignoredAtFromProjects(issue.projects)}
        dependency={issue.source.name}
        version={issue.source.version}
        tickets={issue.jiraTickets}
        packageManager={issue.source.packageManager}
        cve={issue.cve}
        exploitability={issue.exploitability}
        epss={issue.epss}
        remediation={issue.remediation}
        depths={issue.depths}
        ignoredKinds={ignoredKindsFromProjects(issue.projects)}
        badge={customRiskScore
          ? <CustomRiskScoreBadge score={customRiskScore.score} />
          : <VulnBadge cvss={issue.cvss} isTruncated={false} />}
      />
    </BaseIssueItem>
  );
};

export default VulnerabilityIssueItem;
